import { selectIsAppInitialized } from '@/shared/redux/slices/appGlobal.slice'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import './SplashScreen.scss'

export const SplashScreen = () => {
  const isInitialized = useSelector(selectIsAppInitialized)
  const [shouldRender, setShouldRender] = useState(true)
  const [isFadingOut, setIsFadingOut] = useState(false)

  useEffect(() => {
    if (isInitialized) {
      setIsFadingOut(true)
      const timer = setTimeout(() => {
        setShouldRender(false)
      }, 600) // Matches CSS transition duration
      return () => clearTimeout(timer)
    }
  }, [isInitialized])

  if (!shouldRender) return null

  return (
    <div className={`splash-screen ${isFadingOut ? 'splash-screen--fade-out' : ''}`}>
      <div className="splash-screen__logo-container">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 771.61 770.5"
          className="splash-screen__svg"
        >
          <defs>
            <linearGradient
              id="qlrvGrad1"
              x1="9.4312"
              y1="385.2486"
              x2="780.1819"
              y2="385.2486"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" style={{ stopColor: '#26489D' }} />
              <stop offset="0.4844" style={{ stopColor: '#5E7DBE' }} />
              <stop offset="0.5034" style={{ stopColor: '#5C7BBD' }} />
              <stop offset="1" style={{ stopColor: '#224A9D' }} />
            </linearGradient>
            <linearGradient
              id="qlrvGrad2"
              x1="1.7017"
              y1="432.4502"
              x2="769.3917"
              y2="432.4502"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" style={{ stopColor: '#4262AD' }} />
              <stop offset="0.4844" style={{ stopColor: '#6585C3' }} />
              <stop offset="1" style={{ stopColor: '#5065A8' }} />
            </linearGradient>
            <linearGradient
              id="qlrvGrad3"
              x1="584.6461"
              y1="507.9691"
              x2="583.584"
              y2="233.2077"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" style={{ stopColor: '#2C2F74', stopOpacity: 0 }} />
              <stop offset="0.7067" style={{ stopColor: '#2D2E73' }} />
              <stop offset="1" style={{ stopColor: '#282B73' }} />
            </linearGradient>
            <linearGradient
              id="qlrvGrad4"
              x1="186.963"
              y1="508.2279"
              x2="186.963"
              y2="254.7945"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" style={{ stopColor: '#2B2F73', stopOpacity: 0 }} />
              <stop offset="0.7067" style={{ stopColor: '#2D2E72' }} />
              <stop offset="1" style={{ stopColor: '#2D2E72' }} />
            </linearGradient>
          </defs>

          {/* Outer Shield */}
          <path
            className="splash-screen__path splash-screen__path--outer"
            stroke="url(#qlrvGrad1)"
            fill="url(#qlrvGrad1)"
            strokeWidth="3"
            d="M767.14,143.54c-4.25-46-44.94-98.42-145.83-122.22C531.36,0.1,410.51-0.17,385.38,0.02 C360.25-0.17,239.4,0.1,149.44,21.32C48.56,45.12,7.86,97.54,3.62,143.54c-5.14,55.65-4.49,121.87,0,169.61 c2.76,29.41,11.43,130.44,94.55,256.15c8.27,12.52,17.29,25.28,27.1,38.24C248.75,770.5,385.36,770.5,385.36,770.5l0.02-2.52 l0.01,2.52c0,0,136.62,0,260.09-162.96C753.92,464.42,764.1,345.49,767.14,313.15C771.63,265.41,772.28,199.19,767.14,143.54z"
          />

          {/* Inner Shield */}
          <path
            className="splash-screen__path splash-screen__path--inner"
            stroke="url(#qlrvGrad2)"
            fill="url(#qlrvGrad2)"
            strokeWidth="3"
            d="M642.46,157.42 c-62.58-36.22-161.66-62.28-257.1-62.28c-93.45,0-197.74,12.71-260.22,49.76c-93.59,55.5-123.44,143-123.44,143 s1.31,18.1,1.91,24.51c2.76,29.41,11.44,130.44,94.55,256.15c8.28,12.52,17.29,25.28,27.11,38.24 c123.48,162.96,260.09,162.96,260.09,162.96l0.02-2.52l0.02,2.52c0,0,136.61,0,260.09-162.96 C753.92,463.68,764.1,344.75,767.14,312.41c0.55-5.82,2.25-30.61,2.25-30.61S735.1,211.04,642.46,157.42z"
          />

          {/* Left Side Shadow */}
          <path
            className="splash-screen__path splash-screen__path--left-shadow"
            stroke="url(#qlrvGrad4)"
            fill="url(#qlrvGrad4)"
            strokeWidth="3"
            d="M302.4,392.95 c-22.98-21.89-37.29-52.78-37.29-87.01c0-35.94,15.79-68.19,40.8-90.22c-46.52,12.81-93.89,37.49-132.86,77.6 C111.03,357.15,68.02,481.58,68.02,518.92l218.45,0.27L302.4,392.95z"
          />

          {/* Right Side Shadow */}
          <path
            className="splash-screen__path splash-screen__path--right-shadow"
            stroke="url(#qlrvGrad3)"
            fill="url(#qlrvGrad3)"
            strokeWidth="3"
            d="M505.43,305.94 c0,34.23-14.32,65.12-37.29,87.01l15.96,126.49l218.42,0.27c0-30.64-47.63-153.43-100.87-216.18 c-35.29-41.59-84.11-71.45-135.94-86.86C490.09,238.67,505.43,270.52,505.43,305.94z"
          />

          {/* Center Keyhole / Person */}
          <path
            className="splash-screen__path splash-screen__path--keyhole"
            stroke="#ffffff"
            fill="#ffffff"
            strokeWidth="3"
            d="M491.55,577.66H279.21l23.3-184.71c-22.98-21.89-37.29-52.78-37.29-87.01c0-66.36,53.8-120.16,120.16-120.16 s120.16,53.8,120.16,120.16c0,34.23-14.32,65.12-37.29,87.01L491.55,577.66z"
          />
        </svg>
      </div>
    </div>
  )
}

export default SplashScreen
